import Swal from "sweetalert2";

// ✅ Confirm Dialog
export const confirmAlert = async ({
  title = "Are you sure?",
  text = "",
  confirmText = "Yes",
  cancelText = "Cancel",
}) => {
  const result = await Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: "#2563eb",
    cancelButtonColor: "#6b7280",
  });

  return result.isConfirmed;
};

// ✅ Success Alert
export const successAlert = (title = "Success", text = "") => {
  return Swal.fire({
    title,
    text,
    icon: "success",
    timer: 2000,
    showConfirmButton: false,
  });
};

// ✅ Error Alert
export const errorAlert = (title = "Error", text = "") => {
  return Swal.fire({
    title,
    text,
    icon: "error",
  });
};

// ✅ Info Alert
export const infoAlert = (title = "Info", text = "") => {
  return Swal.fire({
    title,
    text,
    icon: "info",
  });
};